// Historical connection rows did not distinguish authentication from recovery.
// New sustained-outage rows carry the shared incident UUID in params[0].
export function isNeutralConnectionEvent(log) {
  if (Number(log?.eventType) === 1048268) return true;
  if (Number(log?.eventType) !== 1048267 || log?.triggered) return false;
  let params = log?.params;
  if (typeof params === 'string') {
    try { params = JSON.parse(params); } catch (_) { params = []; }
  }
  return !Array.isArray(params) || !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(params[0] || '');
}
